﻿'use strict';

angular.module('ntmApp')
  .controller('EventsDialogController', ['$scope', '$uibModalInstance', 'data',
      function ($scope, $uibModalInstance, data) {

          $scope.events = data.events;
          $scope.title = data.date.format(data.dateFormatter);
          $scope.hasEventForm = data.hasEventForm;

          $scope.onEventClicked = function (args) {
              data.onEventClicked(args);
              $uibModalInstance.dismiss();
          };
         
          $scope.close = function (closeType) {
              $uibModalInstance.close(closeType || false);
          };

          $scope.dismiss = function () {
              $uibModalInstance.dismiss();
          };

      }]);